import { CfDataGridRows } from './CfDataGridRows';
import { CfDataGridSkeletonRow } from './CfDataGridSkeletonRow';
import { CfDataGridRowByItemIdProps, CfDataGridRowPropsPassThru } from './common';

export function CfDataGridRowByItemId<TItem, TAppState>(
  props: CfDataGridRowByItemIdProps<TItem, TAppState>
): JSX.Element {
  const itemId = props.itemId;
  if (!itemId) {
    return <CfDataGridSkeletonRow tableViewDefinition={props.tableViewDefinition} itemIndex={props.itemIndex} />;
  }

  const item: TItem | undefined = props.useSelector((state) => props.itemSelector(itemId, state));
  const previousItem: TItem | undefined = props.useSelector((state) =>
    props.previousItemId ? props.itemSelector(props.previousItemId, state) : undefined
  );
  if (item) {
    const rowProps: CfDataGridRowPropsPassThru<TItem, TAppState> = { item, previousItem, ...props };
    delete rowProps.itemId;
    delete rowProps.previousItemId;
    delete rowProps.itemSelector;
    delete rowProps.useSelector;
    return <CfDataGridRows {...rowProps} />;
  }

  return <></>;
}
